import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
import Button from "@material-ui/core/Button";

import React, { useEffect, useState } from "react";
import { deleteEnvironment, getEnvironments,addEnvironment,updateEnvironment } from "../../apis/environment";


export function ManageEnvironment({ show, setShow }) {
  const [envListChanged, setEnvListChanged] = useState(false);
  const [envList, setEnvList] = useState([]);
  const [addEnv, setAddEnv] = useState(false);
  const [newEnv, setNewEnv] = useState({name:"",description:""});
  const [curEnv, setCurEnv] = useState({});
  const ADDACTION = "ADD";
  const UPDATEACTION = "UPDATE";

  useEffect(() => {
    let mounted = true;

    getEnvironments().then((envs) => {
      if (mounted) {
        setEnvList(envs.data);
        console.log(envs.data)
        setEnvListChanged(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, envListChanged);


  function updateEnvOnClick(e, env) {
    console.log("Inside updateEnvOnClick");
    var lEnvList = [...envList];
    var i = lEnvList.findIndex((e)=>env.name === e.name);
    lEnvList[i].makeRowEditable = true;
    setEnvList(lEnvList);
    setNewEnv({...env});
  }

  function deleteEnv(e, env) {
    deleteEnvironment(env);
    setEnvListChanged(true);
  }

  function handleOnChangeAddName(e) {
    
    let lenv = {...newEnv};
    lenv.name = e.target.value;
    setNewEnv(lenv);
  }

  function handleOnChangeAddEnvDescription(e){
      let lenv = {...newEnv};
      lenv.description = e.target.value;
      setNewEnv(lenv);
  }

  function displayDoneCloseButtons(action, env){
    return (<td>
             
    <IconButton onClick={() => handleOnClickDone(action, env)}>
      <DoneIcon />
    </IconButton>
 
 
    <IconButton onClick={() => handleOnClickClose(action, env)}>
      <CloseIcon />
    </IconButton>
  

    </td>);
  }

  function displayAddEnv() {
    if (addEnv) {
    //   setAddEnv(false);
      return (
        <tr>
          <td>
            <TextField
              style={{width: '10ch'}}
              required
              label="Required"
              id="EnvName"
            //   value={newEnv.name}
              onChange={(e) => {
                handleOnChangeAddName(e);
              }}
            />
          </td>
          <td>
            <TextField
              required
              label="Required"
              id="EnvDescription"
            //   value={newEnv.description}
              onChange={(e) => {
                handleOnChangeAddEnvDescription(e);
              }}
            />
          </td>
          {displayDoneCloseButtons(ADDACTION)}
         
        </tr>
      );
    }

    return "";
  }
  function displayNameDescription(env){
    if(env.makeRowEditable){
      
      return(
       <>
        <td>
          <TextField
            style={{width: '10ch'}}
            required
            label="Required"
            id="EnvName"
            defaultValue={env.environment}
            onChange={(e) => {
              handleOnChangeAddName(e);
            }}
          />
        </td>
        <td>
          <TextField
            required
            label="Required"
            id="EnvDescription"
             defaultValue={env.description}
            onChange={(e) => {
              handleOnChangeAddEnvDescription(e);
            }}
          />
        </td>
        
       
      </>
      )
    }

    return (
      <>
      <td>{env.environment}</td>
      <td>{env.description}</td>
      </>
    )
  }
  function handleOnClickDone(action, env) {
    if(action === "ADD"){
      addEnvironment(newEnv);
      setEnvListChanged(true);
      setAddEnv(false);
    }
    if(action === "UPDATE"){
     
      let lenv = {...newEnv};
      lenv.makeRowEditable = false;
      updateEnvironment(lenv);
      setEnvListChanged(true);
      setNewEnv({});
      // let lEnvList = [...envList];
      // let i = lEnvList.findIndex((e)=> e.name === env.name);
      // lEnvList[i] = {...newEnv};
      // setEnvList(lEnvList);
    }
  }

  function handleOnClickClose(action, env) {
    console.log("handleOnClickClose "+action+" "+env)
    if(action === "ADD")
      setAddEnv(false);
    
    if(action === "UPDATE"){
      env.makeRowEditable = false;
      let lEnvList = [...envList];
      let i = lEnvList.findIndex((e)=> e.name === env.name);
      lEnvList[i] = {...env};
      setEnvList(lEnvList);
    }


  }



  function displayActions(env) {
    if(env.makeRowEditable){
      
      return displayDoneCloseButtons(UPDATEACTION,env);
    }
    return (
      <td>
        <Tooltip title="Update Environment">
          <IconButton onClick={(e) => updateEnvOnClick(e, env)}>
            <EditIcon className='roundButton'></EditIcon>
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete Environment">
          <IconButton onClick={(e) => deleteEnv(e, env)}>
            <DeleteIcon className='roundButton'/>
          </IconButton>
        </Tooltip>
      </td>
    );
  }

  if (!show) {
    return "";
  }

  return (
    <div className="modal">
      <div className="modal-content addmodalwidth">
        {/* <Grid container> */}
        <h1 style={{ fontSize: "x-large", color: "black" }}>
          Manage Environment
        </h1>
        <Tooltip title="Close">
          <IconButton
            style={{ float: "right", position: "absolute", right: 0, top: 0 }}
            onClick={() => setShow(false)}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Add Environment">
          <IconButton
            style={{ float: "right" }}
            onClick={() => setAddEnv(true)}
          >
            <AddBoxOutlinedIcon />
          </IconButton>
        </Tooltip>

        <table className="amictb">
          <tr>
            <th>Environments</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
          {displayAddEnv()}
          {envList.map((env) => (
            <tr>
                {displayNameDescription(env)}
                {displayActions(env)}
             
            </tr>
          ))}
        </table>
        {/* </Grid> */}
      </div>
    </div>
  );
}
